const URL_RE = /(https?:\/\/[^\s<>"]+)/g;
const isAudio = (u) => /\.(mp3|wav|ogg|m4a)(\?|$)/i.test(u) || /cdn\.ringover\.com\/records\//i.test(u);

// Texte avec liens cliquables et lecteur audio pour les enregistrements d'appel
export function RichText({ text, className }) {
  const seen = new Set();
  const parts = String(text || "").split(URL_RE);
  return (
    <p className={className}>
      {parts.map((part, i) => {
        if (i % 2 === 0) return part;
        const url = part.replace(/[.,;)]+$/, "");
        if (isAudio(url)) {
          if (seen.has(url)) return null;
          seen.add(url);
          return <audio key={i} className="pl-audio" controls preload="none" src={url} data-testid="timeline-audio-player"><a href={url}>{url}</a></audio>;
        }
        return <a key={i} href={url} target="_blank" rel="noreferrer">{url}</a>;
      })}
    </p>
  );
}
